/* VIBRA conversion system — shared behaviour */
(function(){
  if (window.__vbInit) return; window.__vbInit = true;
  var money = function(c){ return '$' + (c/100).toFixed(2); };

  function initBuy(root){
    if (root.__vb) return; root.__vb = true;
    var form = root.querySelector('[data-vb-form]');
    var tiers = root.querySelectorAll('.vb-tier');
    var btnLabel = root.querySelectorAll('[data-vb-btn-price]');
    var stickyMeta = document.querySelector('[data-vb-sticky-meta]');
    function sync(){
      tiers.forEach(function(t){
        var i = t.querySelector('input');
        t.classList.toggle('is-checked', i.checked);
        if (i.checked){
          var price = parseInt(t.getAttribute('data-total'),10);
          btnLabel.forEach(function(b){ b.textContent = money(price); });
          if (stickyMeta) stickyMeta.textContent = t.getAttribute('data-label') + ' · ' + money(price);
          form.querySelector('[name="quantity"]').value = i.value;
        }
      });
    }
    tiers.forEach(function(t){ t.querySelector('input').addEventListener('change', sync); });
    sync();

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var err = form.querySelector('.vb-error');
      btn.disabled = true; if (err) err.style.display = 'none';
      var vid = parseInt(form.querySelector('[name="id"]').value,10);
      var qty = parseInt(form.querySelector('[name="quantity"]').value,10) || 1;
      var giftEl = form.querySelector('[name="gift_id"]');
      var items = [{id: vid, quantity: qty}];
      var go = form.getAttribute('data-redirect') || '/cart';
      var post = function(list){
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:list})})
          .then(function(r){ if(!r.ok) throw r; return r.json(); });
      };
      var addGift = function(){
        if (!giftEl || !giftEl.value) return Promise.resolve();
        return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
          var has = c.items.some(function(i){ return String(i.variant_id) === String(giftEl.value); });
          if (has) return;
          return post([{id: parseInt(giftEl.value,10), quantity: 1}]).catch(function(){});
        });
      };
      post(items).then(addGift).then(function(){ window.location.href = go; })
        .catch(function(){
          btn.disabled = false;
          if (err){ err.textContent = 'Something went wrong adding to cart. Please try again.'; err.style.display='block'; }
        });
    });

    // gallery
    var stage = root.querySelector('.vb-gallery__stage');
    if (stage){
      var thumbs = root.querySelectorAll('.vb-thumb');
      var dots = root.querySelectorAll('.vb-dots span');
      var slides = stage.children;
      var setActive = function(n){
        thumbs.forEach(function(t,i){ t.classList.toggle('is-active', i===n); });
        dots.forEach(function(d,i){ d.classList.toggle('is-active', i===n); });
        Array.prototype.forEach.call(slides, function(s,i){ var v=s.querySelector('video'); if(v && i!==n) v.pause(); });
      };
      thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ stage.scrollTo({left: slides[i].offsetLeft - stage.offsetLeft, behavior:'smooth'}); setActive(i); }); });
      var to; stage.addEventListener('scroll', function(){ clearTimeout(to); to = setTimeout(function(){ setActive(Math.round(stage.scrollLeft / stage.clientWidth)); }, 60); }, {passive:true});
    }

    // sticky bar
    var sticky = document.querySelector('.vb-sticky');
    var anchor = root.querySelector('[data-vb-atc]');
    if (sticky && anchor && 'IntersectionObserver' in window){
      var footerSeen = false;
      new IntersectionObserver(function(es){ es.forEach(function(e){
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', past);
      }); }).observe(anchor);
      sticky.querySelector('button').addEventListener('click', function(){
        anchor.scrollIntoView({behavior:'smooth', block:'center'});
      });
    }
  }

  function initVideos(){
    var vids = document.querySelectorAll('[data-vb-autoplay]');
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){
      var v = e.target;
      if (e.isIntersecting){ if (!v.src && v.dataset.src){ v.src = v.dataset.src; } var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      else { v.pause(); }
    }); }, {threshold:.35});
    vids.forEach(function(v){ io.observe(v); });
    document.querySelectorAll('.vb-ugc__sound').forEach(function(b){
      b.addEventListener('click', function(){
        var v = b.parentNode.querySelector('video');
        document.querySelectorAll('[data-vb-autoplay]').forEach(function(o){ if(o!==v) o.muted = true; });
        v.muted = !v.muted; b.setAttribute('aria-pressed', String(!v.muted));
        b.innerHTML = v.muted ? b.dataset.off : b.dataset.on;
        if (!v.muted) { var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
      });
    });
  }

  function initReveal(){
    var els = document.querySelectorAll('.vb-reveal');
    if (!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target);} }); }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  function initCartCount(){
    var el = document.querySelectorAll('[data-vb-cart-count]');
    if (!el.length) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      el.forEach(function(e){ e.textContent = c.item_count; e.style.display = c.item_count ? 'flex' : 'none'; });
    }).catch(function(){});
  }

  function boot(){
    document.querySelectorAll('[data-vb-buy]').forEach(initBuy);
    initVideos(); initReveal(); initCartCount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(){ window.__vbInit=false; boot(); });
})();
